import { Card, type CardProps } from '@mui/material';
import { styled } from '@mui/material/styles';

type SurfaceVariant = 'surface' | 'soft';

interface SurfacePanelProps extends CardProps {
  surfaceVariant?: SurfaceVariant;
}

const BasePanel = styled(Card)({
  position: 'relative',
  overflow: 'hidden',
});

const surfaceStyles = ({ theme }: { theme: import('@mui/material/styles').Theme }) => {
  const palette = theme.vars?.palette ?? theme.palette;
  const surface = palette.surface ?? {
    panelBorder: palette.divider,
    shadow: 'none',
    soft: palette.background.default,
    softStrong: palette.divider,
  };

  return {
    borderRadius: theme.shape.card,
    border: `1px solid ${surface.panelBorder}`,
    background: palette.background.paper,
    boxShadow: surface.shadow,
    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.shape.surface,
    },
  };
};

const SoftPanelCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.shape.card,
  padding: theme.spacing(2),
  border: `1px solid ${
    theme.vars?.palette.surface.softStrong ??
    theme.palette.surface?.softStrong ??
    theme.palette.divider
  }`,
  background:
    theme.vars?.palette.surface.soft ??
    theme.palette.surface?.soft ??
    theme.palette.background.default,
  boxShadow: 'none',
}));

const SurfacePanelCard = styled(BasePanel)(surfaceStyles);

export function SurfacePanel({
  children,
  sx,
  surfaceVariant = 'surface',
  ...cardProps
}: SurfacePanelProps) {
  const Panel = surfaceVariant === 'soft' ? SoftPanelCard : SurfacePanelCard;

  return (
    <Panel sx={{ position: 'relative', ...sx }} {...cardProps}>
      {children}
    </Panel>
  );
}
